(function(){
  var root = document.querySelector('[data-dpv2]');
  if (!root) return;
  function readJson(sel, fb){ var el = document.querySelector(sel); if (!el) return fb; try { return JSON.parse(el.textContent); } catch(e){ return fb; } }
  var variants = readJson('[data-dpv2-variants]', []);
  var mhdMap = readJson('[data-dpv2-mhd]', {});
  var stockMap = readJson('[data-dpv2-stockmap]', {});
  var dietMap = readJson('[data-dpv2-diet-map]', {});
  var LOW = 5;
  var inCartMap = {};
  var attrV = root.getAttribute('data-variant');
  var current = attrV ? parseInt(attrV, 10) : null;
  if (!current && variants.length === 1) current = variants[0].id;
  var cartUrl = root.getAttribute('data-cart') || '/cart';
  var cartAddUrl = root.getAttribute('data-cart-add') || '/cart/add';
  var cartTotal = 0;
  var FREE = 6900;
  var qtyEl = root.querySelector('[data-dpv2-qty]');
  var idEl = root.querySelector('[data-dpv2-id]');
  function money(c){ return (c/100).toFixed(2).replace('.', ',') + ' €'; }
  function variant(){ if (!current) return null; for (var i=0;i<variants.length;i++){ if (variants[i].id === current) return variants[i]; } return null; }

  /* Galerie */
  function getMain(){ return root.querySelector('[data-dpv2-main]') || document.querySelector('.dayvee-product__main-media img'); }
  function showImage(src, mediaId){
    var main = getMain();
    if (main && src){ main.src = src; main.removeAttribute('srcset'); }
    root.querySelectorAll('[data-dpv2-thumb]').forEach(function(x){
      x.setAttribute('aria-current', mediaId && String(x.getAttribute('data-media-id')) === String(mediaId) ? 'true' : 'false');
    });
  }
  root.querySelectorAll('[data-dpv2-thumb]').forEach(function(b){
    b.addEventListener('click', function(){ showImage(b.getAttribute('data-dpv2-thumb'), b.getAttribute('data-media-id')); });
  });
  function imgSrc(v, w){
    var fm = v.featured_media;
    var src = fm && fm.preview_image && fm.preview_image.src ? fm.preview_image.src : (v.featured_image && v.featured_image.src);
    if (!src) return null;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function variantImage(v){ var src = imgSrc(v, 1200); if (src) showImage(src, v.featured_media ? v.featured_media.id : null); }

  /* Lieferdatum: 3 bis 5 Werktage */
  function addWorkdays(d, n){ var r = new Date(d); while(n>0){ r.setDate(r.getDate()+1); var w=r.getDay(); if(w!==0 && w!==6) n--; } return r; }
  function fmtDay(d){ var t=['So.','Mo.','Di.','Mi.','Do.','Fr.','Sa.']; return t[d.getDay()] + ', ' + ('0'+d.getDate()).slice(-2) + '.' + ('0'+(d.getMonth()+1)).slice(-2) + '.'; }
  var del = root.querySelector('[data-dpv2-delivery]');
  var HY = root.hasAttribute('data-dpv2-hybrid');
  function shortDay(d){ return ('0'+d.getDate()).slice(-2) + '.' + ('0'+(d.getMonth()+1)).slice(-2) + '.'; }
  if (del){ var now = new Date(); del.textContent = HY ? shortDay(addWorkdays(now,3)) + ' – ' + shortDay(addWorkdays(now,5)) : 'Lieferung ' + fmtDay(addWorkdays(now,3)) + ' – ' + fmtDay(addWorkdays(now,5)); }

  var volHint = root.querySelector('[data-dpv2-volhint]');
  var vol12 = root.querySelector('[data-dpv2-vol12]');
  if (vol12) vol12.addEventListener('click', function(){
    var mx = parseInt(qtyEl.getAttribute('max'), 10);
    qtyEl.value = !isNaN(mx) && mx < 12 ? mx : 12;
    ship();
  });
  function ship(){
    var v = variant();
    var q = Math.max(1, parseInt(qtyEl.value,10) || 1);
    if (volHint){
      volHint.textContent = q >= 12 ? 'Rabatt aktiv – wird im Warenkorb automatisch abgezogen.' : 'Noch ' + (12 - q) + ' Stück bis zum Rabatt. Wird im Warenkorb automatisch abgezogen.';
      volHint.classList.toggle('is-on', q >= 12);
      if (vol12) vol12.hidden = q >= 12;
    }
    var sum = cartTotal + (v ? v.price * q : 0);
    var rest = FREE - sum;
    var done = cartTotal >= FREE;
    var barWrap = root.querySelector('[data-dpv2-barwrap]');
    var txt = root.querySelector('[data-dpv2-shiptext]');
    var ok = root.querySelector('[data-dpv2-shipdone]');
    if (barWrap) barWrap.hidden = done;
    if (ok) ok.hidden = !done;
    txt.hidden = done;
    root.querySelector('[data-dpv2-bar]').style.width = Math.min(100, Math.round(sum / FREE * 100)) + '%';
    txt.textContent = rest > 0 ? 'Mit diesem Produkt fehlen dir noch ' + money(rest) + ' bis zum kostenlosen Versand' : 'Mit diesem Produkt ist dein Versand kostenlos';
  }

  /* Naehrwerttabellen: zur Sorte passende finden */
  var tables = Array.prototype.slice.call(root.querySelectorAll('[data-dpv2-ntable]'));
  function tableFor(v){
    if (!v) return null;
    for (var i=0;i<tables.length;i++){ if (tables[i].getAttribute('data-dpv2-ntable') === 'v:' + v.id) return tables[i]; }
    for (var j=0;j<tables.length;j++){ if (tables[j].getAttribute('data-dpv2-ntable') === v.title) return tables[j]; }
    return null;
  }

  /* Infoleiste: Werte automatisch aus den Naehrwerten (kcal, Zucker, Protein) */
  function num(s){ return parseFloat(String(s).replace(',', '.')); }
  function fmt(n){ return (Math.round(n*10)/10).toString().replace('.', ','); }
  function readValue(t, kind){
    if (!t) return null;
    var ths = t.querySelectorAll('thead th');
    var col = -1, unit = '';
    if (kind === 'protein'){
      col = ths.length - 1;
      var hp = ths[col] ? ths[col].textContent : '';
      unit = /portion/i.test(hp) ? 'Portion' : (/100/.test(hp) ? '100' + ((hp.match(/100\s*(ml|g)/i)||[])[1] ? ' ' + hp.match(/100\s*(ml|g)/i)[1] : '') : '');
    } else {
      for (var i=0;i<ths.length;i++){ if (/100\s*(ml|g)/i.test(ths[i].textContent)){ col = i; unit = '100 ' + ths[i].textContent.match(/100\s*(ml|g)/i)[1]; break; } }
    }
    if (col < 1) return null;
    var re = kind === 'kcal' ? /^Energie/i : (kind === 'zucker' ? /^davon Zucker/i : /^(Protein|Eiweiß|Eiweiss)/i);
    var rows = t.querySelectorAll('tbody tr');
    for (var r=0;r<rows.length;r++){
      var tds = rows[r].querySelectorAll('td');
      if (tds.length > col && re.test(tds[0].textContent.trim())){
        var txt = tds[col].textContent;
        var m = kind === 'kcal' ? txt.match(/([\d.,]+)\s*kcal/i) : txt.match(/([\d.,]+)\s*g/i);
        if (m) return { n: num(m[1]), unit: unit };
      }
    }
    return null;
  }
  function facts(v){
    root.querySelectorAll('[data-dpv2-fact]').forEach(function(f){
      var kind = f.getAttribute('data-dpv2-fact');
      var vals = [];
      var t = tableFor(v);
      if (t){ var one = readValue(t, kind); if (one) vals.push(one); }
      else { tables.forEach(function(x){ var r = readValue(x, kind); if (r) vals.push(r); }); }
      if (!vals.length){ f.hidden = true; return; }
      var min = Math.min.apply(null, vals.map(function(x){ return x.n; }));
      var max = Math.max.apply(null, vals.map(function(x){ return x.n; }));
      var u = vals[0].unit;
      var suffix = kind === 'kcal' ? ' kcal' : ' g';
      var label = kind === 'kcal' ? 'kcal' : (kind === 'zucker' ? 'Zucker' : 'Protein');
      if (u) label += ' / ' + u;
      f.querySelector('b').textContent = label;
      f.querySelector('span').textContent = (min === max ? fmt(min) : fmt(min) + '–' + fmt(max)) + suffix;
      f.hidden = false;
    });
  }

  var DIET = {
    vegan: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 19c0-8 5-13 14-14-1 9-6 14-14 14z"/><path d="M5 19l7-7"/></svg>Vegan',
    vegetarisch: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M8.5 12.5l2.5 2.5 4.5-5"/></svg>Vegetarisch'
  };

  var priceEl = root.querySelector('[data-dpv2-price]');
  var cmpEl = root.querySelector('[data-dpv2-cmp]');
  var saleEl = root.querySelector('[data-dpv2-sale]');
  function sale(v){
    if (!cmpEl || !saleEl) return;
    if (root.hasAttribute('data-dpv2-bundle')){ cmpEl.hidden = true; saleEl.hidden = true; return; }
    var on = v && v.compare_at_price && v.compare_at_price > v.price;
    cmpEl.hidden = !on; saleEl.hidden = !on;
    if (on){ cmpEl.textContent = money(v.compare_at_price); saleEl.textContent = '-' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + ' %'; }
  }
  var unitEl = root.querySelector('[data-dpv2-unit]');
  var unitInit = unitEl ? unitEl.textContent : '';

  function render(withImage){
    var v = variant();
    var atc = root.querySelector('[data-dpv2-atc]');
    var stockRow = root.querySelector('[data-dpv2-stockrow]');
    var mhdWrap = root.querySelector('[data-dpv2-mhdline]');
    var hint = root.querySelector('[data-dpv2-pickhint]');
    var dietEl = root.querySelector('[data-dpv2-diet]');
    var limitEl = root.querySelector('[data-dpv2-limit]');
    var zut = root.querySelectorAll('[data-dpv2-zut]');
    var alEl = root.querySelector('[data-dpv2-allergen]');
    if (limitEl){ limitEl.hidden = true; limitEl.textContent = ''; }
    qtyEl.removeAttribute('max');

    if (!v){
      /* Noch nichts gewaehlt */
      idEl.value = '';
      priceEl.textContent = priceEl.getAttribute('data-dpv2-price-init');
      sale(null);
      if (unitEl){ unitEl.textContent = unitInit; unitEl.hidden = !unitInit; }
      if (stockRow) stockRow.hidden = true;
      if (mhdWrap) mhdWrap.hidden = true;
      if (dietEl) dietEl.hidden = true;
      atc.disabled = true; atc.textContent = 'Bitte auswählen';
      tables.forEach(function(t, i){ t.hidden = i !== 0; });
      if (hint) hint.hidden = tables.length < 2;
      var hasProd = false;
      zut.forEach(function(z){ if (z.getAttribute('data-dpv2-zut') === 'product') hasProd = true; });
      zut.forEach(function(z, i){ z.hidden = hasProd ? z.getAttribute('data-dpv2-zut') !== 'product' : i !== 0; });
      if (alEl) alEl.hidden = true;
      facts(null);
      ship();
      root.dispatchEvent(new CustomEvent('dpv2:rendered'));
      return;
    }

    idEl.value = v.id;
    priceEl.textContent = money(v.price);
    sale(v);
    if (unitEl){
      if (v.unit_price && v.unit_price_measurement){ unitEl.textContent = money(v.unit_price) + ' / ' + v.unit_price_measurement.reference_value + ' ' + v.unit_price_measurement.reference_unit; unitEl.hidden = false; }
      else { unitEl.textContent = unitEl.getAttribute('data-dpv2-unit-init') || ''; unitEl.hidden = !unitEl.textContent; }
    }
    if (stockRow) stockRow.hidden = false;
    if (dietEl){
      var d = dietMap[String(v.id)] || '';
      if (DIET[d]){ dietEl.innerHTML = DIET[d]; dietEl.className = 'dpv2-diet ' + (d === 'vegan' ? 'dpv2-diet--vegan' : 'dpv2-diet--veggie'); dietEl.hidden = false; }
      else { dietEl.hidden = true; }
    }

    var stock = root.querySelector('[data-dpv2-stock]');
    var dot = root.querySelector('[data-dpv2-dot]');
    dot.className = 'dpv2-dot';
    var sm = stockMap[String(v.id)] || {};
    var limited = sm.m && sm.d;
    var inCart = inCartMap[String(v.id)] || 0;
    var remaining = limited ? Math.max(0, (sm.q || 0) - inCart) : null;
    if (!v.available){ stock.textContent = 'Derzeit nicht verfügbar'; dot.classList.add('dpv2-dot--out'); atc.disabled = true; atc.textContent = 'Ausverkauft'; }
    else {
      atc.disabled = false; atc.textContent = 'In den Warenkorb';
      if (sm.m && sm.q > 0 && sm.q <= LOW){ stock.textContent = 'Nur noch ' + sm.q + ' Stück auf Lager'; dot.classList.add('dpv2-dot--low'); }
      else if (sm.m && sm.q > 0){ stock.textContent = sm.q + ' Stück auf Lager'; dot.classList.add('dpv2-dot--ok'); }
      else { stock.textContent = 'Sofort lieferbar'; dot.classList.add('dpv2-dot--ok'); }
      if (HY) stock.textContent = stock.textContent.replace(' auf Lager', '');
      if (limited){
        if (remaining <= 0){
          qtyEl.value = 1; atc.disabled = true; atc.textContent = 'Maximale Menge im Warenkorb';
          if (limitEl && inCart > 0){ limitEl.textContent = 'Du hast bereits ' + inCart + ' Stück im Warenkorb. Aktuell können keine weiteren hinzugefügt werden.'; limitEl.hidden = false; }
        } else {
          qtyEl.setAttribute('max', remaining);
          if ((parseInt(qtyEl.value,10)||1) > remaining) qtyEl.value = remaining;
          if (limitEl && inCart > 0){ limitEl.textContent = 'Du hast bereits ' + inCart + ' Stück im Warenkorb. Du kannst noch ' + remaining + ' hinzufügen.'; limitEl.hidden = false; }
        }
      }
    }

    /* MHD je Sorte */
    if (mhdWrap){
      var m = mhdMap[String(v.id)] || mhdMap['product'] || '';
      mhdWrap.hidden = !m;
      mhdWrap.querySelector('strong').textContent = m;
    }

    /* Naehrwerte je Sorte */
    if (hint) hint.hidden = true;
    var tv = tableFor(v);
    if (tv){ tables.forEach(function(t){ t.hidden = t !== tv; }); }
    else if (tables.length && tables[0].getAttribute('data-dpv2-ntable').indexOf('v:') === 0){ tables.forEach(function(t, i){ t.hidden = i !== 0; }); }

    /* Zutaten je Sorte */
    if (zut.length){
      var hit = false;
      zut.forEach(function(z){ if (z.getAttribute('data-dpv2-zut') === String(v.id)) hit = true; });
      zut.forEach(function(z){ var k = z.getAttribute('data-dpv2-zut'); z.hidden = hit ? k !== String(v.id) : k !== 'product'; });
    }

    /* Allergene: nur aus den Zutaten der gewaehlten Sorte */
    if (alEl){
      var srcZ = null;
      zut.forEach(function(z){ if (!z.hidden && !srcZ) srcZ = z; });
      var tz = srcZ ? srcZ.textContent : '';
      var mm = tz.match(/Allergene:\s*([^.]+)/);
      var several = (tz.match(/Allergene:/g) || []).length > 1;
      if (mm && !several){ alEl.textContent = 'Allergene: ' + mm[1].trim(); alEl.hidden = false; } else { alEl.hidden = true; }
    }

    facts(v);
    if (withImage) variantImage(v);
    ship();
    root.dispatchEvent(new CustomEvent('dpv2:rendered'));
  }

  /* Auswahlmenue */
  var sel = root.querySelector('[data-dpv2-select]');
  if (sel){
    var btn = sel.querySelector('[data-dpv2-select-btn]');
    var list = sel.querySelector('[data-dpv2-select-list]');
    var opts = Array.prototype.slice.call(list.querySelectorAll('[data-dpv2-vopt]'));
    var active = -1;
    function setActive(i){
      opts.forEach(function(o, k){ o.classList.toggle('is-active', k === i); });
      active = i;
      if (opts[i]){ list.setAttribute('aria-activedescendant', opts[i].id); opts[i].scrollIntoView({ block: 'nearest' }); }
    }
    function open(){
      list.hidden = false; btn.setAttribute('aria-expanded', 'true');
      var i = 0; opts.forEach(function(o, k){ if (o.getAttribute('aria-selected') === 'true') i = k; });
      setActive(i); list.focus();
    }
    function close(focusBtn){ list.hidden = true; btn.setAttribute('aria-expanded', 'false'); if (focusBtn) btn.focus(); }
    function choose(o){
      current = parseInt(o.getAttribute('data-dpv2-vopt'), 10);
      opts.forEach(function(x){ x.setAttribute('aria-selected', x === o ? 'true' : 'false'); });
      sel.querySelector('[data-dpv2-select-text]').textContent = o.querySelector('.dpv2-opt-name').firstChild.textContent;
      var th = sel.querySelector('[data-dpv2-select-thumb]');
      var oi = o.querySelector('.dpv2-opt-thumb img');
      th.innerHTML = oi ? '<img src="' + oi.getAttribute('src') + '" alt="">' : '';
      var u = new URL(window.location.href); u.searchParams.set('variant', current); history.replaceState(null, '', u.toString());
      close(true);
      render(true);
      syncLive();
    }
    btn.addEventListener('click', function(){ if (list.hidden) open(); else close(false); });
    opts.forEach(function(o, k){
      o.addEventListener('click', function(){ choose(o); });
      o.addEventListener('mousemove', function(){ if (active !== k) setActive(k); });
    });
    list.addEventListener('keydown', function(e){
      if (e.key === 'ArrowDown'){ e.preventDefault(); setActive(Math.min(opts.length - 1, active + 1)); }
      else if (e.key === 'ArrowUp'){ e.preventDefault(); setActive(Math.max(0, active - 1)); }
      else if (e.key === 'Home'){ e.preventDefault(); setActive(0); }
      else if (e.key === 'End'){ e.preventDefault(); setActive(opts.length - 1); }
      else if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); if (opts[active]) choose(opts[active]); }
      else if (e.key === 'Escape' || e.key === 'Tab'){ close(e.key === 'Escape'); }
    });
    btn.addEventListener('keydown', function(e){ if (e.key === 'ArrowDown' || e.key === 'ArrowUp'){ e.preventDefault(); open(); } });
    document.addEventListener('click', function(e){ if (!list.hidden && !sel.contains(e.target)) close(false); });
  }

  /* Vergleichsansicht: Auswahl an das Live-Layout weitergeben (Bild, Naehrwerte unten) */
  function syncLive(){
    if (!root.hasAttribute('data-dpv2-hybrid')) return;
    var v = variant(); var live = document.querySelector('.dayvee-product');
    if (!v || !live) return;
    live.querySelectorAll('[data-dayvee-option]').forEach(function(s, i){
      var val = v.options && v.options[i];
      if (val != null && s.value !== val){ s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }

  /* Gutscheinwert als Buttons */
  var amounts = root.querySelectorAll('[data-dpv2-amount]');
  amounts.forEach(function(b){
    b.addEventListener('click', function(){
      current = parseInt(b.getAttribute('data-dpv2-amount'), 10);
      amounts.forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var u = new URL(window.location.href); u.searchParams.set('variant', current); history.replaceState(null, '', u.toString());
      render(false);
    });
  });

  root.querySelector('[data-dpv2-minus]').addEventListener('click', function(){ qtyEl.value = Math.max(1,(parseInt(qtyEl.value,10)||1)-1); ship(); });
  root.querySelector('[data-dpv2-plus]').addEventListener('click', function(){ var mx = parseInt(qtyEl.getAttribute('max'),10); var n = (parseInt(qtyEl.value,10)||1)+1; if (!isNaN(mx) && n > mx) n = mx; qtyEl.value = Math.max(1,n); ship(); });
  qtyEl.addEventListener('input', ship);

  root.querySelectorAll('[data-dpv2-tab]').forEach(function(tab){
    tab.addEventListener('click', function(){
      root.querySelectorAll('[data-dpv2-tab]').forEach(function(x){ x.setAttribute('aria-selected','false'); });
      tab.setAttribute('aria-selected','true');
      root.querySelectorAll('[data-dpv2-panel]').forEach(function(p){ p.hidden = p.getAttribute('data-dpv2-panel') !== tab.getAttribute('data-dpv2-tab'); });
    });
  });

  /* In den Warenkorb: Drawer des Themes öffnen statt Seitenwechsel */
  var form = root.querySelector('[data-dpv2-form]');
  var errEl = root.querySelector('[data-dpv2-err]');
  if (form){
    form.addEventListener('submit', function(e){
      if (!idEl.value || root.getAttribute('data-dpv2-block') === '1'){ e.preventDefault(); if (sel) sel.querySelector('[data-dpv2-select-btn]').focus(); else if (amounts.length) amounts[0].focus(); return; }
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return; /* kein Drawer: normales Absenden */
      e.preventDefault();
      var atc = root.querySelector('[data-dpv2-atc]');
      atc.setAttribute('aria-busy','true'); atc.disabled = true;
      if (errEl){ errEl.hidden = true; errEl.textContent = ''; }
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
      fetch(cartAddUrl + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r){ return r.json(); })
        .then(function(res){
          if (res.status){
            var msg = res.description || res.message || 'Das hat leider nicht geklappt.';
            if (msg && typeof msg === 'object') msg = Object.keys(msg).map(function(k){ return [].concat(msg[k]).join(' '); }).join(' ');
            if (errEl){ errEl.textContent = msg; errEl.hidden = false; }
            render(false);
            return;
          }
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          if (res.sections && res.sections['cart-icon-bubble']){
            var bubble = document.getElementById('cart-icon-bubble');
            var html = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (bubble && html) bubble.innerHTML = html.innerHTML;
          }
          drawer.renderContents(res);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'){
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: res.variant_id, cartData: res });
          }
          document.dispatchEvent(new CustomEvent('dayvee:cart-updated', { detail: res }));
          return loadCart();
        })
        .catch(function(){ form.submit(); })
        .finally(function(){ atc.removeAttribute('aria-busy'); });
    });
  }

  /* Herstellerangaben: Etikett der ersten Zeile ("Hersteller / verantwortlicher Lebensmittelunternehmer:") wird zur Ueberschrift */
  root.querySelectorAll('.dpv2-maker .dpv2-rich').forEach(function(box){
    var first = box.querySelector('p');
    var sum = box.parentElement.querySelector('summary');
    if (first && sum && /:\s*$/.test(first.textContent.trim()) && /Hersteller|Lebensmittelunternehmer/.test(first.textContent)){
      sum.textContent = first.textContent.trim().replace(/:\s*$/, '');
      first.remove();
    }
  });

  /* Popups (Frage zum Produkt, Versand): in den Body verschieben, damit sie ueber allem liegen */
  var lastFocus = null;
  var modals = document.querySelectorAll('[data-dpv2-modal]');
  modals.forEach(function(m){ document.body.appendChild(m); });
  function openModal(m){ if (!m) return; lastFocus = document.activeElement; m.hidden = false; document.documentElement.style.overflow = 'hidden'; var f = m.querySelector('input:not([type=hidden]), textarea') || m.querySelector('[data-dpv2-close].dpv2-modal-x'); if (f) f.focus(); }
  function closeModal(m){ if (!m || m.hidden) return; m.hidden = true; document.documentElement.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  var shipLink = root.querySelector('.dpv2-tax a[href*="versandinformationen"]');
  if (shipLink) shipLink.setAttribute('data-dpv2-open', 'Dpv2Shipping');
  var askBtn = root.querySelector('[data-dpv2-ask]');
  if (askBtn) askBtn.setAttribute('data-dpv2-open', 'Dpv2Question');
  root.querySelectorAll('[data-dpv2-open]').forEach(function(t){
    t.addEventListener('click', function(e){ var m = document.getElementById(t.getAttribute('data-dpv2-open')); if (!m) return; e.preventDefault(); openModal(m); });
  });
  modals.forEach(function(m){
    m.querySelectorAll('[data-dpv2-close]').forEach(function(b){ b.addEventListener('click', function(){ closeModal(m); }); });
    if (m.querySelector('[data-dpv2-qopen]')) openModal(m);
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') modals.forEach(closeModal); });

  function loadCart(){
    return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        cartTotal = c.total_price || 0;
        inCartMap = {};
        (c.items || []).forEach(function(it){ var k = String(it.variant_id); inCartMap[k] = (inCartMap[k] || 0) + it.quantity; });
        render(false);
      })
      .catch(function(){});
  }

  /* Vergleichsansicht: neue Kaufkachel ersetzt nur die alte Kaufkachel im Live-Layout */
  if (root.hasAttribute('data-dpv2-hybrid')){
    var place = function(){
      var live = document.querySelector('.dayvee-product');
      var card = live && live.querySelector('[data-dayvee-info-card]');
      if (!card){ root.setAttribute('data-dpv2-placed', ''); return; }
      card.parentNode.insertBefore(root, card);
      card.style.setProperty('display', 'none', 'important');
      root.setAttribute('data-dpv2-placed', '');
      /* Kasten unter dem Bild: Sinnvoll fuer + Einordnung nebeneinander, Doppeltes raus, Klarheitscheck als Zeile */
      var box = live.querySelector('[data-dayvee-orientation-card]');
      if (box){
        box.classList.add('dpv2-obox');
        if (box.classList.contains('is-single')){
          var grid = box.querySelector('.dayvee-product__orientation-grid');
          box.querySelectorAll('.dayvee-product__orientation-tile').forEach(function(t){
            var h = t.querySelector('h3'); var tx = h ? h.textContent.trim() : '';
            if (/^(Einnahme|Packungsinhalt)$/i.test(tx)) t.style.setProperty('display', 'none', 'important');
          });
          var hl = box.querySelector('.dayvee-product__orientation-highlight');
          if (grid && hl) grid.appendChild(hl);
        }
        var rt = document.querySelector('[data-dpv2-routines]');
        var head = box.querySelector('.dayvee-product__orientation-header');
        if (rt && head && !box.querySelector('.dpv2-passt')){
          var names = rt.innerHTML.replace(/&amp;/g, '&').split(/\s*[·,]\s*/).map(function(x){ return x.trim(); }).filter(Boolean);
          if (names.length){
            var pz = document.createElement('div'); pz.className = 'dpv2-passt';
            var lb = document.createElement('span'); lb.textContent = 'Passt zu: ';
            pz.appendChild(lb);
            names.forEach(function(n){ var tg = document.createElement('span'); tg.className = 'dpv2-tag'; tg.textContent = n; pz.appendChild(tg); });
            head.appendChild(pz);
          }
        }
        var chk = root.querySelector('.dpv2-check');
        if (chk) box.appendChild(chk);
      }
    };
    /* erst nach dem Start des Live-Layouts einsetzen, damit dessen Skript nur seine eigene Kachel findet */
    if (document.readyState === 'complete') place();
    else document.addEventListener('DOMContentLoaded', function(){ setTimeout(place, 0); });
  }

  render(false);
  loadCart();
  /* Mengen im Drawer geaendert -> Bestand/Versand neu rechnen */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'){
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(evt){ if (!evt || evt.source !== 'product-form') loadCart(); });
  }
})();
